module.exports = __webpack_public_path__ + "img/bg.ab51b761.jpg";